import { useParams } from "react-router-dom";
import PageTitle from "../layouts/pageTitle/pageTitle";
import { useEffect, useState } from "react";
import { getCdeDetails } from "../../api/searchApi";
import Spinner from "../layouts/spinner/spinner";
import PageHeader from "../layouts/pageHeader/pageHeader";
import { CSVLink } from "react-csv";
import "./cdeDetails.css";
import getCurrentDateTime from "../layouts/getDate/getCurrentDateTime";


const CdeDetails = () => {
  let { reportType, crfcdeId, domain, subDomain, crfName } = useParams();
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState(null);

  const columns = [
    "CDE ID",
    "CDE Name",
    "Variable Name",
    "Definition",
    "Short Description",
    "Question Text",
    "Permissible Values",
    "PV Descriptions",
    "Data Type",
    "Disease Specific Instructions",
    "Disease Specific Reference",
    "Population",
    "Classification (e.g., Core)",
    "Version Number",
    "Version Date",
    "CRF Module / Guideline",
    "Sub Domain Name",
    "Domain Name",
    "Size",
    "Input Restrictions",
    "Min Value",
    "Max Value",
    "Measurement Type",
    "ExternalID_LOINC",
    "ExternalID_SNOMED",
    "ExternalID_caDSR",
    "ExternalID_CDISC",
  ];

  useEffect(() => {
    const doSearch = async () => {
      setIsSearching(true);

      //console.log(crfcdeId);
      let results = await getCdeDetails(reportType,crfcdeId);
      //console.log(results);
      setSearchResults(results);
      setIsSearching(false);
    };

    doSearch();
  }, [crfcdeId,reportType]);

  const headers = columns.map((col) => ({
    label: col,
    key: col
      .toLowerCase()
      .replace(/ /g, "")
      .replace(/[^a-zA-Z0-9]/g, ""),
  }));

  const formatData = (data) => {
    return data.map((item) => {
      return {
        cdeid: item.cdeId,
        cdename: item.cdeName,
        variablename: item.suggestedName,
        definition: item.definition,
        shortdescription: item.shortDescription,
        questiontext: item.additionalNotes,
        permissiblevalues: item.permissibleValues,
        pvdescriptions: item.pvDescriptions,
        datatype: item.dataType,
        diseasespecificinstructions: item.diseaseSpecificInstructions,
        diseasespecificreference: item.diseaseSpecificReference,
        population: item.population,
        classification: item.classification,
        versionnumber: item.version,
        versiondate: item.versionDate,
        crfmoduleguideline: item.crfName,
        subdomainname: item.subDomainName,
        domainname: item.domainName,
        size: item.size,
        inputrestrictions: item.inputRestrictions,
        minvalue: item.minValue,
        maxvalue: item.maxValue,
        measurementtype: item.measurementType,
        externalid_loinc: item.externalID_LOINC,
        externalid_snomed: item.externalID_SNOMED,
        externalid_cadsr: item.externalID_caDSR,
        externalid_cdisc: item.externalID_CDISC,
      };
    });
  };


  return (
    <>
      <PageTitle>CDE Detailed Report</PageTitle>
      <PageHeader>
        This report contains detailed information about the selected CDEs.
      </PageHeader>
      <PageHeader>
        <br />
        {domain && (
          <>
            <strong>Domain:</strong> {domain}
            <br />
          </>
        )}
        {subDomain && (
          <>
            <strong>Sub-Domain:</strong> {subDomain}
            <br />
          </>
        )}
        {crfName && (
          <>
            <strong>CRF:</strong> {crfName}
            <br />
          </>
        )}
      </PageHeader>
      <hr />
      {isSearching && <Spinner />}
      {searchResults && (
        <>
          <div className="cdeDetail-table-wrapper">
            <div className="cdeDetail-table">
              <table>
                <thead>
                  <tr>
                    {columns.map((c) => (
                      <th key={c}>{c}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((r) => (
                    <tr key={r.cdeId}>
                      <td>{r.cdeId}</td>
                      <td>{r.cdeName}</td>
                      <td>{r.suggestedName}</td>
                      <td>{r.definition}</td>
                      <td>{r.shortDescription}</td>
                      <td>{r.additionalNotes}</td>
                      <td>{r.permissibleValues}</td>
                      <td>{r.pvDescriptions}</td>
                      <td>{r.dataType}</td>
                      <td>{r.diseaseSpecificInstructions}</td>
                      <td>{r.diseaseSpecificReference}</td>
                      <td>{r.population}</td>
                      <td>{r.classification}</td>
                      <td>{r.version}</td>
                      <td>{r.versionDate}</td>
                      <td>{r.crfName}</td>
                      <td>{r.subDomainName}</td>
                      <td>{r.domainName}</td>
                      <td>{r.size}</td>
                      <td>{r.inputRestrictions}</td>
                      <td>{r.minValue}</td>
                      <td>{r.maxValue}</td>
                      <td>{r.measurementType}</td>
                      <td>{r.externalID_LOINC}</td>
                      <td>{r.externalID_SNOMED}</td>
                      <td>{r.externalID_caDSR}</td>
                      <td>{r.externalID_CDISC}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <hr />
            </div>
          </div>
          <button className="download-btn-primary">
            <CSVLink
              className="csv-link"
              data={formatData(searchResults)}
              headers={headers}
              filename={`cde-details_${getCurrentDateTime()}.csv`}
            >
              Download the CSV dataset
            </CSVLink>
          </button>
        </>
      )}
    </>
  );
};

export default CdeDetails;
